import { useCallback } from 'react';
import { Pressable, PressableProps, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import { spacing } from '../../../theme';
import { Text } from '../../Text';
import BackIcon from './arrow-left.svg';
import { withTranslation } from '../../../locales/hoc';

export const HeaderBackButton = withTranslation((props: PressableProps) => {
	const { t } = useTranslation();
	const { canGoBack, goBack, navigate } = useNavigation();

	const handleGoBack = useCallback(() => {
		canGoBack() ? goBack() : navigate('Home');
	}, [canGoBack, goBack, navigate]);

	return (
		<Pressable style={styles.root} onPress={handleGoBack} {...props}>
			<BackIcon />
			<Text>{t('common.back')}</Text>
		</Pressable>
	);
});

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing(0.5),
	},
});
